import React, { PropTypes } from 'react';

import TicketListItem from '../TicketListItem';

import { unstyledList } from '../../../../base-styles/mixins.module.css';
import { heading2 } from '../../styles.module.css';
import { list } from './styles.module.css';

/**
 * Ticket list presentational component.
 */
const TicketList = ({ races }) => (
  <ul className={unstyledList}>
    {races.map(race => (
      <li key={race.id}>
        <article className={list}>
          <h2 className={heading2}>{race.title}</h2>
          {race.tickets && (
            <ul className={unstyledList}>
              {race.tickets.tickets.map(ticket => (
                <li key={ticket.id}>
                  <TicketListItem ticket={ticket} />
                </li>
              ))}
            </ul>
          )}
        </article>
      </li>
    ))}
  </ul>
);

TicketList.propTypes = {
  races: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    tickets: PropTypes.shape({
      tickets: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
      })).isRequired,
    }),
  })).isRequired,
};

export default TicketList;



// WEBPACK FOOTER //
// ./app/src/components/EventTicketsPage/components/TicketList/index.jsx